const phoneNumber = (value, { locale, skipLengthValidation = false }) => {
  const phoneNumberChars = /^[0-9\-.()+\s]*$/i;

  if (!value) {
    return null;
  }

  if (!phoneNumberChars.test(value)) {
    return locale['common.phoneNumber.error'];
  }

  const numbers = value.replace(/\D/gi, '');

  /** @description CB-19336 Phase1: all that is required is it is 10 number */
  if (!skipLengthValidation && numbers.length !== 10) {
    return locale['common.phoneNumber.error'];
  }

  return null;
};

export default phoneNumber;
